import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    Grid,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";

const RFQBuyers = ({value, setValue, data = [], hasAll = false, error, isDisabled}) => {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const [checked, setChecked] = useState(true);
    const [disabled, setDisabled] = useState(true);


    const refreshClicked = useSelector((state) => state.buttonSlice.refreshClicked);

    useEffect(() => {
        if (refreshClicked) {
            setChecked(true);
            setDisabled(true)
        }
    }, [refreshClicked])

    const handleCheckChange = (event) => {
        const isChecked = event.target.checked;
        setChecked(isChecked);
        setDisabled(isChecked);
        if (isChecked) {
            setValue([-1]);
        } else {
            setValue([]);
        }
    };

    const handleChange = (event) => {
        const selectedStatus = event.target.value;
        setValue(selectedStatus);
        setChecked(selectedStatus.includes(-1));
    };

    useEffect(() => {
        if (value?.includes(-1)) {
            setChecked(true)
            setDisabled(true)
        }
    }, [value]);

    return (
        hasAll ? (
            <Grid container spacing={1}>
                <Grid item xs={9}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Buyers</InputLabel>
                        <Select
                            multiple
                            value={value || []}
                            disabled={disabled}
                            style={{
                                color: (disabled || isDisabled) && 'black !important',
                                background: (disabled || isDisabled) && 'hsl(0, 0%, 95%)'
                            }}
                            onChange={handleChange}
                            input={<OutlinedInput label="Buyers"/>}
                            MenuProps={MenuProps}
                            renderValue={(selected) => {
                                if (selected.includes(-1)) {
                                    return 'All';
                                }
                                return selected
                                    .map((x) => data?.find((y) => y.buyerCode === x)?.buyerName)
                                    .join(', ');
                            }}
                        >
                            {data?.map((item) => (
                                <MenuItem key={item.buyerCode} value={item.buyerCode}>
                                    <Checkbox checked={value?.includes(item.buyerCode)}/>
                                    <ListItemText primary={item.buyerName}/>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox checked={checked} onChange={handleCheckChange}/>
                            }
                            label="All"
                        />
                    </FormGroup>
                </Grid>
            </Grid>
        ) : (
            <FormControl size="small" fullWidth>
                <InputLabel>Buyer</InputLabel>
                <Select
                    disabled={isDisabled}
                    label="Buyer"
                    value={value || ''}
                    error={Boolean(error)}
                    onChange={(event) => {
                        setValue(event.target.value);
                    }}
                    style={{
                        color: isDisabled && 'black !important',
                        background: isDisabled && 'hsl(0, 0%, 95%)'
                    }}
                >
                    <MenuItem value={''}>
                        None
                    </MenuItem>
                    {data.map(item => (
                        <MenuItem key={item.buyerCode} value={item.buyerCode}>
                            {item.buyerName}
                        </MenuItem>
                    ))}
                </Select>
                {error && (
                    <FormHelperText
                        sx={{color: '#d32f2f', ml: 0}}>{error.message || 'This field is required'}</FormHelperText>
                )}
            </FormControl>
        )
    )
}

export default RFQBuyers
